module.exports = {
  apiPrefix: 'https://test.gene.thorgene.com/mweb-gene-api',
  apiPrefixV2: 'https://admin.test.thorgene.com',
  ncovPrefix: 'https://test.gene.thorgene.com',
  // ncovPrefix: 'http://192.168.1.28:3000',
  ncovRegisterPreFix: 'https://test.gene.thorgene.com',
  crmNcovRegisterPreFix: 'https://crm.ncov.test.thorgene.com',
  checkupApiPrefix: 'http://qa.old-checkup.thorgene.net/mweb-checkup-api',
  fePrefix: 'https://test.gene.thorgene.com',
  // appId: 'wx68959ce94ca93c1b', // SZSC 公众号
  appId: 'wxbcbdcf90352fb0f7',
  wxAuthPrefix: 'https://account.thorgene.com/api',
  checkUpPrefix: 'https://test.gene-report.thorgene.com'
};


// WEBPACK FOOTER //
// ./src/config/test.js